import { Typography } from '@mui/material';
import { useAppSelector } from 'api';
import { ProviderTable } from './ProviderTable';
import { PageContainer } from 'app';

export const ProviderPage = () => {
  const { currentMenuItem } = useAppSelector(state => state.menuItem);

  return (
    <PageContainer>
      <Typography variant="subtitle1">{currentMenuItem?.text}</Typography>
      <ProviderTable />
    </PageContainer>
  );
};
